export default "__VITE_ASSET__CYzB7OVM__"